// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2POjo","notes":"Notes_notes__32xx0","note":"Notes_note__o2-Zd","markdown":"Notes_markdown__2t3GQ"};